import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import SimpleBar from 'simplebar-react';
import { NumericFormat } from 'react-number-format';
import { formatQuotaionNumber } from 'src/common/helper';
// import DialogQuotation from './dialog/DialogQuotation';

const Quotations = (props: any) => {
  const quotesProps = props.quotes || [];
  // const patient = props.patient || null;
  // const [openDialogDetail, setOpenDialogDetail] = useState<boolean>(false);
  // const [rowId, setRowId] = useState('');
  const [view, setView] = useState(false);

  // const handleOpenDialogDetail = (id: any) => {
  //   props.handleQuotationDetail(id)
  // };

  // const handleCloseDialogDetail = () => {
  //   setOpenDialogDetail(false);
  // };

  const handleView = () => {
    setView(!view);
  };

  return (
    <Stack
      width={'100%'}
      className={`${view ? 'showAll' : 'showLess'}`}
      sx={{
        backgroundColor: 'primary.light',
        '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
          backgroundColor: '#CCD1D9',
        },
        '&.showAll .simplebar-root': { maxHeight: 'max-content !important' },
        '&.showLess .simplebar-root': { maxHeight: '234px !important' },
      }}
      borderTop={'4px solid #ED5565'}
      mb={'16px'}
    >
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        p={'5px 16px'}
        height={'48px'}
      >
        <Typography fontSize={'14px'} fontWeight={700}>
          見積
        </Typography>
        <Stack direction={'row'} spacing={'8px'}>
          <Box
            component={'img'}
            src={`/images/icons/ic-arrow-${view ? 'up' : 'down'}.svg`}
            alt='edit'
            sx={{ cursor: 'pointer' }}
            width={'24px'}
            onClick={handleView}
          />
          <Box
            component={'img'}
            src='/images/icons/ic-plus.svg'
            alt='edit'
            sx={{ cursor: 'pointer' }}
            width={'24px'}
            onClick={props.handleAddQuote}
          />
          <Box
            component={'img'}
            src='/images/icons/ic-drag-drop.svg'
            alt='edit'
            sx={{ cursor: 'pointer' }}
            width={'24px'}
          />
        </Stack>
      </Stack>
      <SimpleBar style={{ maxHeight: '234px' }} className='simplebar-root'>
        <TableContainer component={Paper}>
          <Table aria-label='simple table'>
            <TableHead
              sx={{ '& th': { py: '4px', fontSize: '14px', fontWeight: 700 } }}
            >
              <TableRow>
                <TableCell>発行日</TableCell>
                <TableCell>タイトル</TableCell>
                <TableCell>見積番号</TableCell>
                <TableCell>担当医師</TableCell>
                <TableCell>金額</TableCell>
                <TableCell>ステータス</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ '& td': { fontSize: '14px', fontWeight: 400 } }}>
              {quotesProps.map((row: any, index: number) => (
                <TableRow
                  hover
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    cursor: 'pointer',
                  }}
                  onClick={() => props.handleQuotationDetail(row.id)}
                >
                  <TableCell>{row.quotedate}</TableCell>
                  <TableCell>{row.title}</TableCell>
                  <TableCell>{formatQuotaionNumber(row.id)}</TableCell>
                  <TableCell>{row.doctor}</TableCell>
                  <TableCell>
                    <NumericFormat
                      displayType='text'
                      value={row.amount}
                      thousandSeparator
                    />
                  </TableCell>
                  <TableCell>{row.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SimpleBar>

      {/* <DialogQuotation
        open={openDialogDetail}
        onClose={handleCloseDialogDetail}
        id={rowId}
        patientId={patient?.id || null}
      /> */}
    </Stack>
  );
};

export default Quotations;
